import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PageInfo } from './service-common';

export interface Pageable {
  page: number;
  size: number;
  sort?: string[];
}

export type SerieType = 'SALE' | 'SUBSCRIPTION' | 'INVOICE' | 'SALE_LINK' | 'MIT_MANDATE';

export interface SerieDTO {
  id: number;
  type: SerieType;
  serie: string;
  description?: string;
  sequence?: number;
  padding: number;
  state: 'ACTIVE' | 'INACTIVE';
  createdAt?: string;
  updatedAt?: string;
}

export interface SerieFilterSpec {
  [key: string]: string | number | boolean | string[] | undefined | null;
}

export interface WrapperPageableResponseSerie {
  ok: boolean;
  code: number;
  message: string;
  metadata?: unknown;
  body: SerieDTO[];
  page?: PageInfo;
}

export interface WrapperResponseSerie {
  ok: boolean;
  code: number;
  message: string;
  metadata?: unknown;
  body: SerieDTO;
}

export interface CreateSerieRequest {
  type: SerieType;
  serie?: string;
  description?: string;
  sequence?: number;
  padding?: number;
}

export interface UpdateSerieRequest {
  type?: SerieType;
  serie?: string;
  description?: string;
  padding?: number;
}

@Injectable({
  providedIn: 'root'
})
export class SerieService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getSeries(
    spec: SerieFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseSerie> {
    let params = new HttpParams();

    Object.entries(spec).forEach(([key, value]) => {
      if (value === undefined || value === null) return;
      if (Array.isArray(value)) {
        if (value.length > 0) {
          value.forEach(v => params = params.append(key, String(v)));
        }
      } else if (value !== '') {
        params = params.append(key, String(value));
      }
    });

    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));

    if (pageable.sort && pageable.sort.length > 0) {
      pageable.sort.forEach(sort => params = params.append('sort', sort));
    }

    return this.http.get<WrapperPageableResponseSerie>(`${this.apiUrl}/series`, { params });
  }

  getSerieById(id: number): Observable<WrapperResponseSerie> {
    return this.http.get<WrapperResponseSerie>(`${this.apiUrl}/series/${id}`);
  }

  createSerie(request: CreateSerieRequest): Observable<WrapperResponseSerie> {
    return this.http.post<WrapperResponseSerie>(`${this.apiUrl}/series`, request);
  }

  updateSerie(id: number, request: UpdateSerieRequest): Observable<WrapperResponseSerie> {
    return this.http.put<WrapperResponseSerie>(`${this.apiUrl}/series/${id}`, request);
  }

  deleteSerie(id: number): Observable<WrapperResponseSerie> {
    return this.http.delete<WrapperResponseSerie>(`${this.apiUrl}/series/${id}`);
  }
}
